export const DEPARTMENT_COLOR_VALIDATION_MESSAGE =
    "Please assign a color to every department, or leave all departments without a color.";

export const DEPARTMENT_COLOR_VALIDATION_TOAST_ID =
    "department-color-validation";

export function isValidHexColor(value) {
    return /^#([0-9a-fA-F]{6}|[0-9a-fA-F]{8})$/.test(value);
}

function hasDepartmentColor(department) {
    return typeof department?.colorHex === "string" && department.colorHex.trim() !== "";
}

export function hasValidDepartmentColorConfiguration(departments) {
    const totalDepartments = departments.length;
    const departmentsWithColor = departments.filter(hasDepartmentColor).length;

    return departmentsWithColor === 0 || departmentsWithColor === totalDepartments;
}
